import React, { FC } from 'react';

import { CustomerFeedbackCard } from '@eika-forsikring/customer-feedback-card';

import { sporreskjemaLink } from './sporreskjema-button';

import './customer-feedback-link.scss';

const CustomerFeedbackLink: FC = () => (
    <div className="kvittering__customer-feedback-link">
        <CustomerFeedbackCard title="Hjelp oss å bli bedre" text="Gi oss tilbakemelding" url={sporreskjemaLink} />
    </div>
);

export default CustomerFeedbackLink;
